import ConfirmModal from '~/components/common/ConfirmModal';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  patientPreferredFullName: string;
  onConfirmClick: () => void | null;
};
export const CreateAssessmentDiagnosisOverrideModal = ({
  isOpen,
  closeModal,
  patientPreferredFullName,
  onConfirmClick,
}: Props) => {
  return (
    <ConfirmModal
      body={`${patientPreferredFullName} does not have an applicable diagnosis on file for this assessment. Overriding this restriction should only be done if you intend to use the data in support of adding the diagnosis. If this action was taken in error, please dismiss this notice.`}
      cancelLabel="Dismiss"
      confirmLabel="Override"
      confirmVariant="accent.critical"
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={onConfirmClick}
      title="Are you sure you wish to send this assessment?"
    />
  );
};
